import { render, staticRenderFns } from "./GenericListSubHeader.vue?vue&type=template&id=5399cba4&scoped=true&"
import script from "./GenericListSubHeader.vue?vue&type=script&lang=js&"
export * from "./GenericListSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./GenericListSubHeader.vue?vue&type=style&index=0&id=5399cba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5399cba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
